import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影频道",
    desc: "最新院线大片、经典佳作，动作、科幻、悬疑一网打尽",
    count: "12000+ 部",
    accent: "bg-primary-500 hover:bg-primary-600",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧频道",
    desc: "热播剧集每日更新，古装、都市、悬疑追剧不停歇",
    count: "8000+ 部",
    accent: "bg-accent-500 hover:bg-accent-600",
  },
];

export default function CategoryEntry() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {entries.map((entry, i) => (
          <Link
            key={entry.to}
            to={entry.to}
            className={`group relative overflow-hidden rounded-lg p-6 md:p-8 text-background-50 transition-colors cursor-pointer animate-fade-up ${
              entry.accent
            } ${i === 1 ? "animate-delay-2" : ""}`}
          >
            <div className="flex items-start justify-between">
              <div>
                <span className="w-12 h-12 rounded-lg bg-background-50/20 flex items-center justify-center mb-4">
                  <i className={`${entry.icon} text-2xl`}></i>
                </span>
                <h3 className="text-xl md:text-2xl font-heading font-bold">{entry.title}</h3>
                <p className="mt-2 text-sm text-background-50/85 max-w-xs leading-relaxed">
                  {entry.desc}
                </p>
              </div>
              <span className="text-sm font-label text-background-50/70 whitespace-nowrap">
                {entry.count}
              </span>
            </div>
            <div className="mt-6 flex items-center gap-1 text-sm font-label">
              进入频道
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </div>
            <i className="ri-film-line absolute -right-4 -bottom-6 text-8xl text-background-50/10 rotate-12"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}